const state = {};

const getters = {};

const mutations = {};

const actions = {
  async fetchAll(ctx) {
    try {
      let {
        data: { data: customers },
      } = await axios.get('/api/customers');
      return customers;
    } catch (error) {
      throw error.response.data;
    }
  },

  async add(ctx, data) {
    try {
      let {
        data: { success, message },
      } = await axios.post('/api/customers', data);
      return { success, message };
    } catch (error) {
      throw error.response.data;
    }
  },

  async fetchByID(ctx, id) {
    try {
      let {
        data: { data: customer },
      } = await axios.get(`/api/customers/${id}`);
      return customer;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateByID(ctx, { id, data }) {
    try {
      let {
        data: { success, message },
      } = await axios.put(`/api/customers/${id}`, data);
      return { success, message };
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteByID(ctx, id) {
    try {
      let {
        data: { success, message },
      } = await axios.post(`/api/customers/${id}`, { _method: 'delete', customer: id });
      return { success, message };
    } catch (error) {
      throw error.response.data;
    }
  },

  async fetchExtraField() {
    try {
      let {
        data: { data: extra_field },
      } = await axios.get(`/api/customers/extra_fields`);

      return extra_field;
    } catch (error) {
      throw error.response.data;
    }
  },
};

const namespaced = true;

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced,
};
